import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { IDataService } from '../../../../services/data/data-service.interface';

@Component({
  selector: 'gtd-offer-vertical',
  templateUrl: './offer-vertical.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferVerticalComponent {
  @Input() data: number | null;
  public offerVerticals: Record<string, string>;

  constructor(@Inject('IDataService') public globalData: IDataService) {
    this.offerVerticals = this.globalData.getData().verticals;
  }
}
